import { styled } from "@mui/material/styles";
import { Grid } from "./../../../Grid";

export const StyledGrid = styled(Grid)`
  margin-top: 10px;
  margin-bottom: 10px;
`;
